import * as z from 'zod/mini';
import type { Market } from '@//config/domain-locale-map';
import type { TranslatorFor } from '@//locales/messages';
import { odometerReadingSchema, registrationNumberSchemaByMarket } from '@//utils/zod-schemas';

export const valuationSchema = (market: Market, t: TranslatorFor<'utils.validation'>) =>
  z.object({
    registrationNumber: registrationNumberSchemaByMarket(market, t),
    odometerReading: odometerReadingSchema(t),
  });

export type ValuationSchemaType = z.infer<ReturnType<typeof valuationSchema>>;
